import { ComponentProps } from 'react';
import { Chip, TypographyColor } from 'melp-design/components';
import { ClaimStatus, TaxExemptionAnalysisStatus } from './claims.types';

export const COLOR_BY_STATUS: Record<ClaimStatus, TypographyColor> = {
  approved: 'success',
  paid: 'primary',
  rejected: 'error',
  pendingEmployeeAction: 'warning',
  pendingHRAction: 'warning',
};

export const CHIP_VARIANT_BY_TAX_EXEMPTION_ANALYSIS_STATUS: Record<
  TaxExemptionAnalysisStatus,
  ComponentProps<typeof Chip>['variant']
> = {
  eligible: 'success',
  nonEligible: 'error',
  unsure: 'warning',
};

export const COMPANY_EXPENSE_ID = 'companyExpense';
